
		<!-- Navbar Toggler -->
		<!-- (click)="leftSidebar.toggleSideBar()" -->
		<button pmd-btn pmdRipple pmd-btn-fab pmd-btn-flat size="xs"
			(click)="toggleSideBar()"
			class="pmd-sidebar-toggle d-xl-none pmd-btn-rounded" 
			aria-label="Press enter to open the left sidebar navigation">
			<i class="material-icons-round md-light">menu</i>
		</button>
		<!-- Navbar brand -->

		<div class="d-flex">
			<img src="assets/images/kanz-logo-white.png" class="fils-logo-white" alt="PayKanz" height="40">			  
		</div>

		<!-- <div class="d-flex align-items-center d-none d-sm-flex">
			<div>
				<h1 tabindex="0" class="mb-0 text-white">{{localMessage.title}}</h1>
				<nav aria-label="breadcrumb" class="breadcrumb mb-0">
					<ol class="breadcrumb pmd-breadcrumb pmd-breadcrumb-dark">
						<li *ngFor = "let b of localMessage.breadcrumb; index as i; first as isFirst; last as isLast;" class="breadcrumb-item" [ngClass]="{'active': isLast}">
							<a *ngIf="!isLast && !b.link" href="javascript:void(0)">{{b.name}}</a>
							<a *ngIf="!isLast && b.link" [routerLink]="[b.link]">{{b.name}}</a>
							<ng-container *ngIf="isLast">{{b.name}}</ng-container>
						</li>
					</ol>
				</nav>
			</div>
		</div> -->

		<pmd-navbar-right-icon class="d-flex align-items-center pf-navbar-right-icon py-3">
			<form class="language-dropdown-form">
				<pmd-input-group-outline pmd-input-group-icon class="language-dropdown">
					<pmd-input-group-text>
						<i class="material-icons material-symbols-rounded md-light pmd-icon-sm">
							language
						</i>
					</pmd-input-group-text>
					<ng-select placeholder="Press Enter to select language"
						ariaLabel="Press Enter to select language" appearance="outline" [searchable]="false"
						pmdTextField [clearable]="false" labelForId="languageId" name="language"
						[(ngModel)]="language" (change)="changeLang()"
						class="pmd-select pmd-select-dark pmd-select-sm pmd-select-outline">
						<ng-option *ngFor="let l of languages" [value]="l.id">{{l.name}}</ng-option>
					</ng-select>
				</pmd-input-group-outline>
			</form>
			<!-- <div class="dropdown pmd-dropdown pmd-user-info" pmdDropdown>
				<button type="button" pmdDropdownToggle pmd-btn-fab pmd-btn-raised color="warning" size="sm" class="position-relative dropdown-toggle me-0">
					FA
				</button>
				<ul class="dropdown-menu dropdown-menu-right" *pmdDropdownMenu aria-labelledby="userNavbarDropdown"
					role="menu">
					<li>
						<a class="dropdown-item d-flex align-items-center" routerLinkActive='active'
							routerLink="/settings" pmdRipple aria-label="Press enter to view profile"
							role="menuitem" tabindex="0">
							<span class="material-icons material-symbols-rounded me-2" aria-hidden="true">person</span>My Profile</a>
					</li>
					<li>
						<a class="dropdown-item d-flex align-items-center" routerLinkActive='active'
							routerLink="/login" pmdRipple aria-label="Press enter to logout from the tool"
							role="menuitem" tabindex="0">
							<span class="material-icons material-symbols-rounded me-2" aria-hidden="true">logout</span>Logout</a>
					</li>
				</ul>
			</div> -->
		</pmd-navbar-right-icon>